import { SwitchCase } from "@/v2-components/switch-case";
import { ProductSlug } from "@/api/product-api";
import TactVisorInstallation from "@/components/tactsuit/tactvisor/TactVisorInstallation";
import TactGloveInstallation from "@/components/shop/details/TactGloveInstallation";

const InstallationGuide = ({ slug = "" }) => {
  return (
    <SwitchCase
      defaultComponent={null}
      caseBy={{
        [ProductSlug.TACTVISOR]: <TactVisorInstallation />,
        [ProductSlug.TACTGLOVE_DK2]: <TactGloveInstallation />,
      }}
      value={slug}
    />
  );
};

export default InstallationGuide;
